import { BASE_URL } from "@/constants/endpoints";
import { CashRequestStatus } from "@/constants/entity-status";
import { CashRequestDetail } from "@/pages/requests/cash/schema/cash-requests.schema";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

let cashRequestsApiPromise: Promise<AxiosInstance> | null = null;

const getCashRequestsApi = async (): Promise<AxiosInstance | null> => {
  if (cashRequestsApiPromise) return cashRequestsApiPromise;
  cashRequestsApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return cashRequestsApiPromise;
};

export interface GetCashRequestsProps {
  fechaDesde: string;
  fechaHasta: string;
  monto: string;
  nroCuenta: string;
  idSucursal: number[];
  estados: number[];
  "P.Pagina": number;
  "P.Records": number;
}

export const getCashRequests = async (props: GetCashRequestsProps) => {
  const api = await getCashRequestsApi();
  if (!api) return null;
  const response = await api.get(
    `/SolicitudEfectivo/GetListadoSolicitudes?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface GetCashRequestProps {
  id: number;
}

export const getCashRequest = async (
  props: GetCashRequestProps,
): Promise<CashRequestDetail | null> => {
  const api = await getCashRequestsApi();
  if (!api) return null;
  const response = await api.get(
    `/SolicitudEfectivo/GetDetalleSolicitudEfectivo?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface CreateCashRequestProps {
  idCuentaOrigen: number;
  monto: number;
  claveSucursal: string
  idUsuarioMobile: number;
  mensaje?: string;
}

export const createCashRequest = async (props: CreateCashRequestProps) => {
  const api = await getCashRequestsApi();
  if (!api) return null;
  const response = await api.post(
    `/SolicitudEfectivo/CrearSolicitud?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};

export interface UpdateCashRequestProps {
  idSolicitud: number;
  estado?: CashRequestStatus;
  idMotivo?: number;
  monto?: number;
  mensaje?: string;
}

export const updateCashRequest = async (props: UpdateCashRequestProps) => {
  const api = await getCashRequestsApi();
  if (!api) return null;
  const response = await api.put(
    `/SolicitudEfectivo/EditarSolicitudEfectivo?${objectToQueryStringWithArray(props)}`,
  );

  return response.data;
};
